(function($) {
	$('.navbar-button').on('click', function() {
		$('#navbarNav').add('.languages-menu').toggleClass('open');
		$('body').toggleClass('no-scroll');
		if($('.navbar').css('position') != 'fixed'){
			$('.navbar').css('position', 'fixed');
		}else{
			if(screen.width < 576){
				$('.navbar').css('position', 'relative');
			}
		}

	});



	if(window.innerWidth > 768) {
		$('.menu-item-has-children').on("mouseenter", function() {
			$(this).find('> .navbar-nav').stop().slideDown();
		}).on("mouseleave", function() {
			$(this).find('> .navbar-nav').stop().slideUp();
		});
	} else {
		$('.menu-item-has-children > .nav-link').on("click", function(e) {
			e.preventDefault();
			$(this).parent().toggleClass('open');
			$(this).parent().find('> .navbar-nav').stop().slideToggle();
		});
	}
})(jQuery);
